export const BUDGET_OPTIONS = [
  { id: "le-1500", label: "S$ ≤1500/月" },
  { id: "1500-2000", label: "S$ 1500–2000/月" },
  { id: "2000-2500", label: "S$ 2000–2500/月" },
  { id: "2500-plus", label: "S$ 2500+/月" },
] as const;

export const ROOM_TYPE_OPTIONS = [
  { id: "single", label: "单人间" },
  { id: "double", label: "双人间" },
  { id: "whole", label: "整套" },
  { id: "unsure", label: "还不确定" },
] as const;

export const PROPERTY_TYPE_OPTIONS = [
  { id: "hdb", label: "HDB" },
  { id: "condo", label: "Condo" },
  { id: "coliving", label: "Coliving" },
  { id: "any", label: "都可以" },
] as const;

export const MOVE_IN_OPTIONS = [
  { id: "this_month", label: "本月" },
  { id: "next_month", label: "下月" },
  { id: "within_3_months", label: "3 个月内" },
  { id: "within_6_months", label: "半年内" },
] as const;

export type BudgetId = (typeof BUDGET_OPTIONS)[number]["id"];
export type RoomTypeId = (typeof ROOM_TYPE_OPTIONS)[number]["id"];
export type PropertyTypeId = (typeof PROPERTY_TYPE_OPTIONS)[number]["id"];
export type MoveInId = (typeof MOVE_IN_OPTIONS)[number]["id"];
export type IntakeSource =
  | "section5"
  | "section4"
  | "community"
  | "unit"
  | "home"
  | "footer"
  | "header"
  | "other"
  | "service";

export const INTAKE_PRIVACY_NOTE =
  "信息仅用于管家跟进你的租房咨询，不会用于其他用途。称呼请填写方便顾问识别的名字即可。";
